import { render, staticRenderFns } from "./DiscountOfferNew.vue?vue&type=template&id=989ac710&scoped=true"
import script from "./DiscountOfferNew.vue?vue&type=script&lang=js"
export * from "./DiscountOfferNew.vue?vue&type=script&lang=js"
import style0 from "./DiscountOfferNew.vue?vue&type=style&index=0&id=989ac710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989ac710",
  null
  
)

export default component.exports